class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.isMegaMenu = this.mainDetailsToggle.classList.contains('mega-menu');
    this.summaryToggle = this.mainDetailsToggle.querySelector('summary');
    this.closeTimer = null;
    this.closeOnScroll = this.closeOnScroll.bind(this);

    if (this.isMegaMenu) {
      this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
      this.mainDetailsToggle.addEventListener('keyup', this.onKeyUp.bind(this));
    }
  }

  onSummaryClick(event) {
    if (!this.isMegaMenu) return;

    event.preventDefault();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.close();
    } else {
      this.open();
    }
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    event.preventDefault();
    this.close();
    this.summaryToggle.focus();
  }

  open() {
    if (!this.isMegaMenu) return;

    clearTimeout(this.closeTimer);
    this.closeHeaderOverlays();
    this.mainDetailsToggle.setAttribute('open', '');
    this.summaryToggle.setAttribute('aria-expanded', true);
    this.setHeaderBottomPosition();
    this.bindScrollClose();

    requestAnimationFrame(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
  }

  close() {
    if (!this.isMegaMenu) {
      super.close();
      return;
    }

    if (!this.mainDetailsToggle.hasAttribute('open')) return;

    clearTimeout(this.closeTimer);
    this.mainDetailsToggle.classList.remove('menu-opening');
    this.summaryToggle.setAttribute('aria-expanded', false);
    this.unbindScrollClose();
    if (this.header) this.header.preventHide = false;

    const removeOpen = () => {
      this.content.removeEventListener('transitionend', onTransitionEnd);
      this.mainDetailsToggle.removeAttribute('open');
    };

    const onTransitionEnd = (event) => {
      if (event.target !== this.content || event.propertyName !== 'transform') return;
      clearTimeout(this.closeTimer);
      removeOpen();
    };

    this.content.addEventListener('transitionend', onTransitionEnd);
    this.closeTimer = setTimeout(removeOpen, 500);
  }

  closeHeaderOverlays() {
    document.querySelectorAll('header-menu').forEach((menu) => {
      if (menu !== this && typeof menu.close === 'function') menu.close();
    });

    document.querySelectorAll('details-modal.header__search').forEach((modal) => {
      if (typeof modal.close === 'function') modal.close(false);
    });
  }

  bindScrollClose() {
    window.addEventListener('scroll', this.closeOnScroll, { passive: true });
    window.addEventListener('wheel', this.closeOnScroll, { passive: true });
    window.addEventListener('touchmove', this.closeOnScroll, { passive: true });
  }

  unbindScrollClose() {
    window.removeEventListener('scroll', this.closeOnScroll);
    window.removeEventListener('wheel', this.closeOnScroll);
    window.removeEventListener('touchmove', this.closeOnScroll);
  }

  closeOnScroll() {
    this.close();
  }

  setHeaderBottomPosition() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.hasAttribute('open');

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }

  onToggle() {
    this.setHeaderBottomPosition();
  }
}

customElements.define('header-menu', HeaderMenu);
